import * as types from './actionsTypes';

export const loadPlaces = (places = []) => {
    return {
        type: types.PLACES_LOAD,
        places,
    };
};
